export default [
  {
    role: 'Credit',
    pages: [
      { title: 'Master', authorize: 'All' },
      { title: 'Configuration', authorize: 'All' },
      { title: 'Cutoff Document', authorize: 'All' },
      { title: 'Customer', authorize: 'All' },
      { title: 'Users', authorize: 'All' },
      { title: 'Role', authorize: 'All' },
      { title: 'Risk Category', authorize: 'All' },
      { title: 'Bill Collector', authorize: 'All' },
      { title: 'Payment Term', authorize: 'All' },
      { title: 'Customers Bank', authorize: 'All' },
      { title: 'Payment Bank', authorize: 'All' },
      { title: 'Incoming GL', authorize: 'All' },
      { title: 'Credit Team', authorize: 'All' },
      { title: 'Credit Team Mapping', authorize: 'All' },
      { title: 'TradeType', authorize: 'All' },
      { title: 'Bill Method', authorize: 'All' },
      { title: 'Payment Type', authorize: 'All' },
      { title: 'SCG Holiday', authorize: 'All' },
      { title: 'Bank Holiday', authorize: 'All' },
      { title: 'Main Sales Employee', authorize: 'All' },
      { title: 'E-mail Group', authorize: 'All' },
      { title: 'Config E-mail', authorize: 'All' },
      { title: 'Invoice Management', authorize: 'All' },
      { title: 'Invoice & DP for Logistic WH', authorize: 'All' },
      { title: 'Following PO', authorize: 'All' },
      { title: 'Following Invoice', authorize: 'All' },
      { title: 'Outsource', authorize: 'All' },
      { title: 'New Outsource', authorize: 'All' },
      { title: 'Calling & Daily', authorize: 'All' },
      { title: 'BU Messenger', authorize: 'All' },
      { title: 'E-mail', authorize: 'All' },
      { title: 'EMS', authorize: 'All' },
      { title: 'Customer System', authorize: 'All' },
      { title: 'Document Management', authorize: 'All' },
      { title: 'Bill Presentment & Invoice', authorize: 'All' },
      { title: 'Receipt', authorize: 'All' },
      { title: 'Request Cancel Credit Block', authorize: 'All' },
      { title: 'Bill Of Exchange', authorize: 'All' },
      { title: 'Domestic Letter Of Credit', authorize: 'All' },
      { title: 'Payment Management', authorize: 'All' },
      { title: 'Following Payment', authorize: 'All' },
      { title: 'Incoming Payment', authorize: 'All' },
      { title: 'Search Problem', authorize: 'All' },
      { title: 'Late Charge', authorize: 'All' },
      { title: 'Postpone Cheque', authorize: 'All' },
      { title: 'Cheque Return', authorize: 'All' },
      { title: 'G/L Statement', authorize: 'All' },
      { title: 'Control Management', authorize: 'All' },
      { title: 'Highlight Overdue', authorize: 'All' },
      { title: 'Risk Management', authorize: 'All' },
      { title: 'Debenture', authorize: 'All' },
      { title: 'Insurance', authorize: 'All' },
      { title: 'Report', authorize: 'All' },
      { title: 'Plan Cash In Flow', authorize: 'All' },
      { title: 'Overdue Report', authorize: 'All' },
      { title: 'Late Charge Report', authorize: 'All' },
      { title: 'Cheque Return Report', authorize: 'All' },
      { title: 'Export Payment', authorize: 'All' },
      { title: 'Following Payment Export', authorize: 'All' },
      { title: 'Incoming Payment Export', authorize: 'All' },
      { title: 'Search Problem Export', authorize: 'All' },
      { title: 'Overdue Report Export', authorize: 'All' },
      { title: 'Credit Advice', authorize: 'All' },
      { title: 'Work Flow', authorize: 'All' },
      { title: 'Questionnaires', authorize: 'All' },
      { title: 'Main Sales Group Sales Office', authorize: 'All' },
      { title: 'Select-In / Select-Out', authorize: 'All' },
      { title: 'Insurance Company', authorize: 'All' },
      { title: 'Sales Volume by Credit Term', authorize: 'All' },
      { title: 'Upload Data', authorize: 'All' },
      { title: 'KPI Overdue', authorize: 'All' },
      { title: 'SCGP Management Committee', authorize: 'All' },
      { title: 'Snap Credit Master', authorize: 'All' }
    ]
  },
  {
    role: 'WH',
    pages: [
      { title: 'Invoice Management', authorize: 'All' },
      { title: 'Invoice & DP for Logistic WH', authorize: 'All' }
    ]
  },
  {
    role: 'Logistic',
    pages: [
      { title: 'Invoice Management', authorize: 'All' },
      { title: 'Invoice & DP for Logistic WH', authorize: 'All' }
    ]
  },
  {
    role: 'Sales',
    pages: [
      { title: 'Work Flow', authorize: 'All' },
      { title: 'Late Charge', authorize: 'All' },
      { title: 'Postpone Cheque', authorize: 'All' },
      { title: 'Request Cancel Credit Block', authorize: 'All' },
      { title: 'Document Management', authorize: 'All' },
      { title: 'Bill Of Exchange', authorize: 'All' },
      { title: 'Domestic Letter Of Credit', authorize: 'All' },
      { title: 'Payment Management', authorize: 'All' },
      { title: 'Cheque Return', authorize: 'All' }
    ]
  },
  {
    role: 'Audit',
    pages: []
  }
];
